import { lightTheme, darkTheme } from '@controlrooms/design-tokens';

export type DropdownTheme = {
  optionTextColor: string;
  titleTextColor: string;
  optionBackgroundColor: string;
  dividerColor: string;
  itemHoverBackgroundColor: string;
};

export const dropdownTheme = Object.fromEntries(
  Object.entries({ light: lightTheme, dark: darkTheme }).map(([key, theme]) => [
    key,
    {
      optionTextColor: theme.color.text.core['-primary'],
      titleTextColor: theme.color.text.core['-tertiary'],
      optionBackgroundColor: theme.color.surface[0],
      dividerColor: theme.color.surface[3],
      itemHoverBackgroundColor: theme.color.surface[1],
    },
  ]),
);

// Legacy exports for backward compatibility
export const dropdownDarkTheme: DropdownTheme = dropdownTheme.dark as DropdownTheme;
export const dropdownLightTheme: DropdownTheme = dropdownTheme.light as DropdownTheme;
